export default __webpack_public_path__ + "04fd741c11ba9f02c727a5045230845a.wav";